import React, { useEffect } from 'react'

import { RibbonTriggerContainer } from 'RibbonTrigger'
import classnames from 'classnames'
import { LayoutPageWrapper, VerticalStages, VerticalStagesItem } from 'goustouicomponents'
import PropTypes from 'prop-types'

import Overlay from 'components/Overlay'
import { AgeVerificationPopUp } from 'components/Product/AgeVerification'
import { MultipleBoxesDeliveryMessage } from 'routes/OrderConfirmation/components/MultipleBoxesDeliveryMessage/MultipleBoxesDeliveryMessage'
import { PageLoader } from 'routes/OrderConfirmation/components/PageLoader'

import { Market } from './components/Market'
import { OrderConfirmationHeader } from './components/OrderConfirmationHeader'
import { OrderFeedback } from './components/OrderFeedback/OrderFeedback'
import { ReferAFriend } from './components/ReferAFriend'

import css from './OrderConfirmation.css'

const propTypes = {
  ageVerified: PropTypes.bool.isRequired,
  canEditOrder: PropTypes.bool.isRequired,
  headerDetails: PropTypes.oneOfType([
    PropTypes.shape({
      deliveryDate: PropTypes.string,
      deliveryStart: PropTypes.string,
      deliveryEnd: PropTypes.string,
      whenCutoffTime: PropTypes.string,
      whenCutoffDate: PropTypes.string,
    }),
    PropTypes.bool,
  ]),
  orderId: PropTypes.string.isRequired,
  showDuplicateOrdersModal: PropTypes.bool.isRequired,
  showHeader: PropTypes.bool.isRequired,
  showMultipleBoxesDeliveryMessage: PropTypes.bool.isRequired,
  userFetchReferralOffer: PropTypes.func.isRequired,
  userVerifyAge: PropTypes.func.isRequired,
  userLoadData: PropTypes.func.isRequired,
  isLoading: PropTypes.bool.isRequired,
  isTransactional: PropTypes.bool.isRequired,
}

const defaultProps = {
  headerDetails: {},
}

export const OrderConfirmation = ({
  ageVerified,
  canEditOrder,
  userFetchReferralOffer,
  userVerifyAge,
  userLoadData,
  headerDetails,
  isLoading,
  showDuplicateOrdersModal,
  showHeader,
  showMultipleBoxesDeliveryMessage,
  orderId,
  isTransactional,
}) => {
  const [hasConfirmedAge, setHasConfirmedAge] = React.useState(false)
  const [showAgeVerification, setShowAgeVerification] = React.useState(false)

  useEffect(() => {
    userFetchReferralOffer()
  }, [userFetchReferralOffer])

  useEffect(() => {
    userLoadData()
  }, [userLoadData])

  const toggleAgeVerificationPopUp = () => {
    setShowAgeVerification(!showAgeVerification)
  }

  const onAgeConfirmation = (isOver18) => {
    setHasConfirmedAge(true)
    userVerifyAge(isOver18, true)
  }

  const isUnderAge = hasConfirmedAge && !ageVerified

  if (isLoading) {
    return <PageLoader />
  }

  return (
    <LayoutPageWrapper padding="large-screens-only">
      <div className={css.pageContent} data-testing="orderConfirmationContainer">
        <Overlay open={showAgeVerification} from="top">
          <AgeVerificationPopUp
            onClose={toggleAgeVerificationPopUp}
            isUnderAge={isUnderAge}
            onAgeConfirmation={onAgeConfirmation}
          />
        </Overlay>

        {showHeader ? (
          <VerticalStages hasFullWidth>
            <VerticalStagesItem
              title={isTransactional ? 'Your one-off order has been placed' : 'Order created'}
              isCompleted
              backgroundColor="lightGrey"
            >
              <div>
                <OrderConfirmationHeader
                  // eslint-disable-next-line react/jsx-props-no-spreading
                  {...headerDetails}
                  isTransactional={isTransactional}
                  canEditOrder={canEditOrder}
                />
                {showMultipleBoxesDeliveryMessage && (
                  <MultipleBoxesDeliveryMessage data-testid="multipleDeliveriesAlert" />
                )}
                <div className={classnames(css.mobileShow, css.rafMobile, css.rafContainer)}>
                  <ReferAFriend />
                </div>
                <div className={classnames(css.mobileShow)}>
                  <OrderFeedback orderId={orderId} />
                </div>
              </div>
            </VerticalStagesItem>

            <VerticalStagesItem
              title="Add desserts, drinks, snacks & more from the Gousto Market"
              isCompleted={false}
            >
              <Market
                ageVerified={ageVerified}
                canEditOrder={canEditOrder}
                showContextualSides={!showDuplicateOrdersModal && canEditOrder}
                toggleAgeVerificationPopUp={toggleAgeVerificationPopUp}
              />
            </VerticalStagesItem>
          </VerticalStages>
        ) : (
          <div>
            <h3 className={css.marketPlaceTitle}>Gousto Market</h3>
            <Market
              ageVerified={ageVerified}
              canEditOrder={canEditOrder}
              toggleAgeVerificationPopUp={toggleAgeVerificationPopUp}
            />
            <div className={classnames(css.mobileShow, css.rafMobile)}>
              <ReferAFriend />
            </div>
          </div>
        )}
      </div>
      <RibbonTriggerContainer name="order-confirmation-web" />
    </LayoutPageWrapper>
  )
}

OrderConfirmation.propTypes = propTypes
OrderConfirmation.defaultProps = defaultProps
